import React, { useCallback, useMemo, useRef } from 'react';
import DateTimePicker from 'utils/packages/dateTimePicker';
import Modal from 'utils/packages/Modal';
import Button from 'design-system/Button';
import { subYears } from 'date-fns';
import { Keyboard, Platform } from 'react-native';
import useColorScheme from './useColorScheme';
export const useDateTimePicker = ({ initialValue = subYears(new Date(), 20), onSubmitDate, mode = 'date', onCloseModal, title, ...props }) => {
    const dateValue = useRef(new Date(initialValue));
    const onSaveButtonPress = useCallback(() => {
        onSubmitDate?.(dateValue.current);
        Modal.hide(onCloseModal);
    }, [onCloseModal, onSubmitDate]);
    const colorScheme = useColorScheme();
    const hideDateTimePicker = useCallback(() => {
        Modal.hide(onCloseModal);
    }, [onCloseModal]);
    const picker = useMemo(() => {
        const androidProps = Platform.OS === 'android'
            ? {
                onChange: (_, date) => {
                    hideDateTimePicker();
                    if (date) {
                        onSubmitDate?.(date);
                    }
                },
                onTouchCancel: () => {
                    hideDateTimePicker();
                },
            }
            : {};
        return (<DateTimePicker themeVariant={colorScheme} value={new Date(initialValue.toString())} display="spinner" mode={mode} onChange={(_event, date) => {
                if (date !== undefined) {
                    dateValue.current = date;
                }
            }} {...props} {...androidProps}/>);
    }, [
        colorScheme,
        hideDateTimePicker,
        initialValue,
        mode,
        onSubmitDate,
        props,
    ]);
    const showDateTimePicker = useCallback(() => {
        Keyboard.dismiss();
        Modal.show(<>
        {picker}
        {Platform.OS !== 'android' && (<Button brand title="Save" onPress={onSaveButtonPress}/>)}
      </>, {
            title: Platform.OS === 'android' ? undefined : title,
            fullscreen: Platform.OS === 'android',
            noBackdrop: Platform.OS === 'android',
            onBackdropPress: onCloseModal,
            onSwipeComplete: onCloseModal,
            onAndroidBackButtonPress: onCloseModal,
        });
    }, [onCloseModal, onSaveButtonPress, picker, title]);
    return {
        showDateTimePicker,
        hideDateTimePicker,
    };
};
